import { CommandBase } from '@shared/commands/command-base';
import { FileAttachment, RecipientModel} from '../models/inbox.model';
import { InboxConfig } from '../inbox-config';
import { Configuration } from '@shared/models/configuration';
/**
 * Created by shamim.ahsan on 6/20/2019.
 */
export class ReplyPlatformMailCommand extends CommandBase {
  constructor (public message:string,
               public recipients:RecipientModel[],
               public fileAttachments:FileAttachment[],
               public mailThreadContentId:string) {
    super(InboxConfig.getReplyPlatformMailApi());
  }
}

export class MarkMailAsReadCommand extends  CommandBase {
  constructor(public mailId: string, public isRead: boolean) {
    super(InboxConfig.getMarkMailAsReadApi());
  }
}
export class DownloadFileCommand extends CommandBase {
  constructor(public fileEntryId: string, public fileContentId: string = '', public isClientFile: boolean = true) {
    super(`${Configuration.getConfig('FileStoreApi')}Command/DownloadFile`);
  }
}
